import { useCallback, useEffect, useMemo } from "react";
import { useAppDispatch } from "./useAppDispatch";
import { useAppSelector } from "./useAppSelector"
import { eReducerStatusBase } from "../state/reducer-model/eReducerStatusBase";
import { rootActions } from "../state/actions/rootActions";
import { useHe } from "./useHe";
import { IDmHe } from "../model/respone/category/IDmHe";
import { useChuyenNganh } from "./useChuyenNganh";
import { IDmChuyenNganh } from "../model/respone/category/IDmChuyenNganh";

export const useLop = (isAll: boolean = false) => {
    const { status, lops } = useAppSelector(x => x.category.lop)
    const { heMap } = useHe();
    const { chuyenNganhMap } = useChuyenNganh();
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (status === eReducerStatusBase.is_not_initialization || status === eReducerStatusBase.is_need_reload) {
            if (isAll) {
                dispatch(rootActions.category.lop.LOAD_ALL_START(undefined))
            } else {
                dispatch(rootActions.category.lop.LOAD_LOP_BY_USER_START(undefined))
            }
        }
    }, [status, dispatch, isAll])
    
    const dataHe: IDmHe[] = useMemo(() => {
        return Array.from(new Set(lops.map(x => x.id_he)))
        .map(x => heMap.get(x))
        .filter((x): x is IDmHe => x !== undefined)
        .sort((a, b) => a.ten_he.localeCompare(b.ten_he))
    }, [lops, heMap])

    const dataKhoaHoc = useMemo(() => {
        return Array.from(new Set(lops.map(x => x.khoa_hoc))).sort((a, b) => b - a)
    }, [lops])

    const dataChuyenNganh = useMemo(() => {
        return Array.from(new Set(lops.map(x => x.id_chuyen_nganh)))
        .map(x => chuyenNganhMap.get(x))
        .filter((x): x is IDmChuyenNganh => x !== undefined)
        .sort((a, b) => a.chuyen_nganh.localeCompare(b.chuyen_nganh))
    }, [lops, chuyenNganhMap])

    //Lấy id_he được phân quyền theo lớp
    const listIdHe: number[] = useMemo(() => {
        return Array.from(new Set(lops.map(x => x.id_he)))
    }, [lops])
    
    return {
        lops,
        dataHe,
        listIdHe,
        isLoading: status === eReducerStatusBase.is_loading,
    }
}